import * as type from '../actions/customAudioPlaylistActionTypes';

const initialState = {
  playlists: [],
  loading: false,
  error: '',
};

export default function customAudioPlaylistReducer(
  state = initialState,
  action,
) {
  switch (action.type) {
    case type.SET_CUSTOM_PLAYLISTS:
      return {
        ...state,
        playlists: action.playlists,
      };

    case type.SET_CUSTOM_PLAYLISTS_LOADING:
      return {
        ...state,
        loading: action.loading,
      };

    case type.SET_CUSTOM_PLAYLISTS_ERROR:
      return {
        ...state,
        error: action.error,
      };

    case type.REMOVE_CUSTOM_PLAYLIST:
      return {
        ...state,
        playlists: state.playlists.filter(
          (playlist) => playlist.id !== action.playlistId,
        ),
      };

    default:
      return state;
  }
}
